import {SharedQuestion} from "./SharedQuestion";

export class TextSharedQuestion extends SharedQuestion {

    protected value:IValue;

    public question:IQuestion;

    isValid():boolean {
        super.isValid();

        if (!this.question.required && !this.validateValue()) {
            return true;
        }

        return this.validateValue() && this.validateMaxCharacters();
    }

    validationMessage():string {
        if (!this.validateMaxCharacters()) {
            return 'text_max_characters_validation_message';
        }

        var message = this.getMessage('required');
        if (message) {
            return message;
        }

        return 'text_validation_message';
    }

    getValue():IValue {
        return this.value;
    }

    setValue(value:IValue) {
        this.value = value;
    }

    satisfiesValue(currentValues:IValue[], value:IValue):boolean {
        return value.value === currentValues[0].value;
    }

    validateMaxCharacters() {
        const maxCharacters = this.question.meta.max_characters;
        if (!maxCharacters) {
            return true;
        }

        return this.validateValue() && this.value.value.length <= maxCharacters;
    }

    validateValue():boolean {
        return this.value && angular.isString(this.value.value) && this.value.value.length > 0;
    }

    isAnswerEmpty(answer: IAnswer): boolean {
        return answer.values.length <= 0 || !answer.values[0].value || answer.values[0].value.length <= 0;
    }
}